import { Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section id="hero" data-nav="light" className="relative overflow-hidden bg-background text-foreground py-20 md:py-28 lg:py-36 border-b border-border">
      {/* Background subtle tint and atmospheric grid line decoration */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,_var(--color-accent)/30,transparent_70%)]" aria-hidden="true" />

      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl lg:text-7xl font-default">
          Refrigerated Trailer Rentals in Los Angeles
        </h1>

        <p className="mx-auto mt-6 max-w-3xl text-base sm:text-lg md:text-xl text-foreground/80 leading-relaxed font-default">
          Fridge Fleet provides mobile refrigerated and freezer trailer options for temporary cold storage in Los Angeles and listed Southern California communities. Trailer options include 6×8, 7×12, and 7×16 trailers plus a 53-foot reefer trailer. Coverage, availability, specifications, temperature requirements, site access, power or fuel needs, rental terms, and scheduling are confirmed with each quote.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="w-full sm:w-auto text-base px-8 h-12 shadow-sm">
            <Link to="/ContactRequestAQuotePage">
              Request a Quote
              <ArrowRight className="size-4 ml-1" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base px-8 h-12 border-border shadow-xs hover:bg-muted">
            <a href="tel:2135218821">
              <Phone className="size-4 mr-1 text-primary" />
              Call 213-521-8821
            </a>
          </Button>
        </div>
      </div>
    </section>;
}